import type { SnippetMap } from "./types";

export const virtualEnvSnippets: SnippetMap = {
  python: ({ token }) => `import oo
import os

# Automatically load into environment variables
oo.load_env("${token}")

# Now use secrets from the env
os.environ["OPENAI_API_KEY"]  # etc.`,

  javascript: ({ token, baseUrl }) => `// Fetch all secrets from a Virtual .env
const response = await fetch("${baseUrl}/api/env", {
  headers: {
    Authorization: "Bearer ${token}",
  },
});
const { secrets } = await response.json();

// secrets is an object: { OPENAI_API_KEY: "sk-...", ... }
console.log(secrets);`,

  curl: ({ token, baseUrl }) =>
    `curl "${baseUrl}/api/env" \\
  -H "Authorization: Bearer ${token}"`,

  r: ({ token, baseUrl }) => `library(httr2)

# Fetch all secrets from a Virtual .env
resp <- request("${baseUrl}/api/env") |>
  req_headers(Authorization = paste("Bearer", "${token}")) |>
  req_perform()

env <- resp_body_json(resp)$secrets

# Set as environment variables
for (key in names(env)) {
  Sys.setenv(key, env[[key]])
}`,
};
